const FOOTER_LINKS = [
  { label: "About Us", href: "https://corefares.com/about-us/" },
  { label: "Privacy Policy", href: "https://corefares.com/privacy-policy/" },
  {
    label: "Terms & Conditions",
    href: "https://corefares.com/terms-conditions/",
  },
];

const FooterLinks = ({ className }) => {
  const year = new Date().getFullYear();

  return (
    <div className={className}>
      <span>{`Corefares \u00A9${year}`}</span>
      {FOOTER_LINKS.map((link) => (
        <a key={link.href} href={link.href} className="hover:underline">
          {link.label}
        </a>
      ))}
    </div>
  );
};

export default FooterLinks;
